<template>
<component :is="post.is_redirect ? 'a' : 'Link'" :href="post.link" class="post-preview flex items-center rounded-lg p-4 vt:p-6 relative overflow-hidden bg-expands" :target="post.is_redirect ? '_blank' : null" :class="wrapperClasses">
    <BackgroundImage v-if="post.thumbnail" :src="post.thumbnail.src" :alt="post.thumbnail.alt" opacity="0.1"></BackgroundImage>
    <div class="relative z-10">
        <span class="kicker transition-colors block text-lg font-headline font-bold uppercase mb-4" :class="post.thumbnail ? 'text-primary-400': 'text-primary-500'" v-html="post.kicker"></span>
        <span class="title transition-colors leading-tight block font-body" :class="post.thumbnail ? 'text-gray-500': 'text-primary-800'" v-html="mainHeadline"></span>
        <span class="author font-headline font-bold transition-colors block mt-2" :class="post.thumbnail ? 'text-gray-500' : 'text-gray-800'" v-if="post.author" v-html="`By ${post.author}`"></span>
    </div>
</component>
</template>

<script>
import { computed } from 'vue';
export default {
    props: {
        post: {
            required: true
        },
        size: {
            default: 'small'
        }
    },
    setup(props) {

        const mainHeadline = computed(() => {
            return props.post.pull_quote
                ? '&ldquo;' + props.post.pull_quote + '&rdquo;'
                : props.post.title;
        });

        const wrapperClasses = computed(() => {
            let output = props.size;
            let background = props.post.thumbnail ? 'bg-primary-700' : 'bg-white';
            return [output, background].join(' ');
        });

        return {
            wrapperClasses,
            mainHeadline
        }
    }
}
</script>